import firebase from '../../src/config/firebase';
require('firebase/auth')

function normalizeUidList(...sources) {
    const list = [];
    for (const source of sources) {
        if (source == null || source === '') continue;
        if (Array.isArray(source)) {
            list.push(...source);
        } else {
            list.push(source);
        }
    }
    return [...new Set(list.filter(Boolean))];
}

function isDriverLinkedToShipper(shipperUids, userShipperUid) {
    if (!userShipperUid) return true;
    const uids = normalizeUidList(shipperUids);
    if (uids.length === 0) return false;
    return uids.includes(userShipperUid);
}

const driverService = {
    

    async getDriverAvailable(id){
        
        return firebase.firestore()
            .collection('drivers_users')
            .doc(id)
            .get()
    },
    
    async getDriverAvailableById(id){
        // console.log("getDriverAvailableById: " + id)
        return firebase.firestore()
            .collection('drivers_users')
            .doc(id)
            .collection('documents')
            .doc("allData")
            .get()
    },

    async getDriverAllByUID(uid) {
        const driverQuerySnapshot = await firebase.firestore()
            .collection('drivers_users')
            .where("uid", "==", uid)
            .get();

        if (driverQuerySnapshot.empty) {
            throw new Error("Motorista não encontrado.");
        }

        // Assumindo que o uid é único, pegue o primeiro documento
        const driverDoc = driverQuerySnapshot.docs[0];
        
        // Agora acesse a subcoleção "documents"
        const allDataDoc = await driverDoc.ref
            .collection('documents')
            .doc('allData')
            .get();

        if (!allDataDoc.exists) {
            throw new Error("Documento 'allData' não encontrado.");
        }

        return {
            driverData: driverDoc.data(),
            allData: allDataDoc.data()
        };
    },

    async getDriverDocuments(id) {
        return firebase.firestore()
            .collection('drivers_users')
            .doc(id)
            .collection('documents')
            .get();
    },

    async getDriverDocumentsUID(uid) {
        return firebase.firestore()
            .collection('drivers_users')
            .where("uid", "==", uid)
            .get();
    },

    async getAllDriver(idShipper){
        const result = await this.getDriversByShipperAccess({
            shipperUids: [idShipper],
        });
        return result.size;
    },

    /**
     * Loads drivers for the logged-in shipper user.
     * Matches shipper UID on root `uidShipper` and on `documents/allData.shipper.uid`.
     */
    async getDriversByShipperAccess({ viewAll = false, shipperUids = [] } = {}) {

        const driversCollection = firebase.firestore().collection('drivers_users');

        if (viewAll) {
            return driversCollection.get();
        }

        const uids = normalizeUidList(...shipperUids);
        if (!uids.length) {
            return { docs: [], empty: true, size: 0 };
        }

        const driverIds = new Set();
        const documentsGroup = firebase.firestore().collectionGroup('documents');

        for (let index = 0; index < uids.length; index += 10) {
            const chunk = uids.slice(index, index + 10);
            const queries = [];

            if (chunk.length === 1) {
                const uid = chunk[0];
                queries.push(
                    driversCollection.where('uidShipper', '==', uid).get(),
                    driversCollection
                        .where('uidShipper', 'array-contains', uid)
                        .get(),
                    documentsGroup
                        .where('shipper.uid', 'array-contains', uid)
                        .get(),
                    documentsGroup.where('shipper.uid', '==', uid).get()
                );
            } else {
                queries.push(
                    driversCollection.where('uidShipper', 'in', chunk).get(),
                    driversCollection
                        .where('uidShipper', 'array-contains-any', chunk)
                        .get(),
                    documentsGroup
                        .where('shipper.uid', 'array-contains-any', chunk)
                        .get(),
                    // shipper.uid may be stored as a string (legacy create);
                    // array-contains-any does not match strings.
                    ...chunk.map((uid) =>
                        documentsGroup.where('shipper.uid', '==', uid).get()
                    )
                );
            }

            const snapshots = await Promise.all(queries);

            snapshots.forEach((snapshot) => {
                snapshot.docs.forEach((doc) => {
                    if (doc.ref.parent?.id === 'documents' && doc.id === 'allData') {
                        const driverId = doc.ref.parent.parent?.id;
                        if (driverId) {
                            driverIds.add(driverId);
                        }
                        return;
                    }

                    if (doc.ref.parent?.id === 'drivers_users') {
                        driverIds.add(doc.id);
                    }
                });
            });
        }

        if (!driverIds.size) {
            return { docs: [], empty: true, size: 0 };
        }

        const driverSnapshots = await Promise.all(
            Array.from(driverIds).map((driverId) =>
                driversCollection.doc(driverId).get()
            )
        );

        const docs = driverSnapshots.filter((snap) => snap.exists);

        return {
            docs,
            empty: docs.length === 0,
            size: docs.length,
        };
    },
    async getAllDriverr(){

        const collectionRef = firebase.firestore()
            .collection('drivers_users')
            .get();
        return collectionRef;

    },

    async updateDriverUidShipper(uidDriver, uidShipperFreight, previousUidShipperDriver) {

        // Normaliza previous em array plano
        const previous = Array.isArray(previousUidShipperDriver)
            ? previousUidShipperDriver.flat()
            : (typeof previousUidShipperDriver === "string"
                ? [previousUidShipperDriver]
                : []);

        // Busca o documento do driver
        const snapshot = await firebase.firestore()
            .collection('drivers_users')
            .doc(uidDriver)
            .collection('documents')
            .get();

        if (snapshot.empty) {
            throw new Error("Driver não encontrado");
        }

        const docSnap = snapshot.docs[0];
        const docRef = docSnap.ref;
        const data = docSnap.data();

        // Normaliza currentUid
        let currentUid = [];

        if (Array.isArray(data.shipper?.uid)) {
            currentUid = data.shipper.uid.flat();
        } else if (typeof data.shipper?.uid === "string") {
            currentUid = [data.shipper.uid];
        }

        // Junta tudo num array único e sem duplicados
        const newUidShipper = Array.from(
            new Set([
                ...currentUid,
                ...previous,
                uidShipperFreight
            ])
        );

        // Atualiza no Firestore
        await docRef.update({
            "shipper.uid": newUidShipper
        });
    },

    async getDriverByCPF(cpf) {
        const cpfClean = cpf.replace(/\D/g, '');

        const snapshot = await firebase.firestore()
            .collection('drivers_users')
            .where('cpf', 'in', [cpf, cpfClean])
            .get();

        if (snapshot.empty) return [];

        return snapshot.docs.map(doc => ({ driverId: doc.id, ...doc.data() }));
    },

    async getDriverShipperUids(driverId) {
        const [rootSnap, allDataSnap] = await Promise.all([
            firebase.firestore()
                .collection('drivers_users')
                .doc(driverId)
                .get(),
            firebase.firestore()
                .collection('drivers_users')
                .doc(driverId)
                .collection('documents')
                .doc('allData')
                .get(),
        ]);

        const rootData = rootSnap.exists ? rootSnap.data() : {};
        const allData = allDataSnap.exists ? allDataSnap.data() : {};

        return normalizeUidList(rootData?.uidShipper, allData?.shipper?.uid);
    },

    async isDriverLinkedToUserShipper(driverId, userShipperUid) {
        const shipperUids = await this.getDriverShipperUids(driverId);
        return isDriverLinkedToShipper(shipperUids, userShipperUid);
    },

    /**
     * Ensures shipper UID(s) exist on driver root `uidShipper` and `allData.shipper.uid`.
     * @param {string} driverId - Firestore document id in `drivers_users`
     * @param {...(string|{ uid?: string })} rawShipperUids
     * @returns {Promise<{ updated: boolean }>}
     */
    async ensureDriverLinkedToShipper(driverId, ...rawShipperUids) {
        const shipperUidsToEnsure = normalizeUidList(
            ...rawShipperUids.flatMap((value) => {
                if (!value) return [];
                if (typeof value === 'string') return [value];
                if (value.uid) return [value.uid];
                return [];
            })
        );

        if (!driverId || !shipperUidsToEnsure.length) {
            return { updated: false };
        }

        const existingUids = await this.getDriverShipperUids(driverId);
        const hasMissingUid = shipperUidsToEnsure.some(
            (uid) => !existingUids.includes(uid)
        );

        if (!hasMissingUid) {
            return { updated: false };
        }

        const mergedUids = normalizeUidList(existingUids, ...shipperUidsToEnsure);

        const rootRef = firebase.firestore()
            .collection('drivers_users')
            .doc(driverId);
        const allDataRef = rootRef.collection('documents').doc('allData');

        const [rootSnap, allDataSnap] = await Promise.all([
            rootRef.get(),
            allDataRef.get(),
        ]);

        if (!rootSnap.exists) {
            throw new Error('Driver not found');
        }

        const batch = firebase.firestore().batch();
        batch.update(rootRef, { uidShipper: mergedUids });

        if (allDataSnap.exists) {
            batch.update(allDataRef, { 'shipper.uid': mergedUids });
        }

        await batch.commit();
        return { updated: true };
    },

    async saveMyFreightToDriver(idDriver, data){
        console.log("Adicionando o frete ao motorista " + data)

        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .add(data)
            // .doc(idFreight)
            // .update(data)
            .catch(error => {
                console.error(error)
            });
    },


    async saveStatusMyFreight(idDriver, idFreight, status){
        console.log("salvando status na fila do MyFrete" + status)

        var data = {
            status: status
        }

        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .doc(idFreight)
            .update(data)
            .catch(error => {
                console.error(error)
            });
    },

    async saveMyFreight(idDriver, idFreight, data){
        console.log("salvando status na fila do MyFrete")

        // Deletar o documento existente antes de salvar
        try {
            await firebase.firestore()
                .collection('drivers_users')
                .doc(idDriver)
                .collection('myFreightsList')
                .doc(idFreight)
                .delete();
        } catch (error) {
            // Ignora erro se o documento não existir
            console.error("Não é documento para deletar:", error);
        }

        // Salvar o novo documento
        firebase.firestore()
                .collection('drivers_users')
                .doc(idDriver)
                .collection('myFreightsList')
                .doc(idFreight)
                .set(data)
            .catch(error => {
                console.error(error)
            });
    },

    async saveClient(clientData) {

        try {
            await firebase.firestore()
                .collection("client")
                .doc()
                .set(clientData);
    
            // alert("Dados atualizados com sucesso!");
        } catch (error) {
            console.error("Erro ao adicionar dados:", error);
        }
    },

    async saveMessageInMyFreight(idDriver, title, message){
        console.log("salvando mensagens na fila do MyFrete ")
        // salvar em drivers_users/uidUser/notifications
        var data = {
            title: title,
            message: message,
            created: new Date()
        }

        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('notifications')
            .add(data)
            .catch(error => {
                console.error(error)
            });

    },


    async deleteStatusMyFreight(idDriver, idFreight){
        console.log("Deletando status na fila do MyFrete")
        
        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .doc(idFreight)
            .delete()
            .catch(error => {
                console.error(error) 
            });
    },


    async deleteDriverAllStatusMyFreight(idDriver, idFreight){
        console.log("Deletando status na fila do MyFrete")
        
        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .doc(idFreight) 
            .delete()
            .catch(error => {
                console.error(error) 
            });
    },
}

export default driverService;